import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SvgComponent = ({ color = designSystem.colors.neutral400, ...props }) => (
    <Svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <Path
            d="M12.167 5.83398C14.0334 5.83398 14.9667 5.83409 15.6797 6.19727C16.3069 6.51684 16.8171 7.02709 17.1367 7.6543C17.4999 8.36726 17.5 9.30057 17.5 11.167V13.834C17.5 15.7008 17.5 16.6346 17.1367 17.3477C16.8171 17.9747 16.3068 18.4842 15.6797 18.8037C14.9667 19.1669 14.0335 19.167 12.167 19.167H7.83301C5.96647 19.167 5.0333 19.1669 4.32031 18.8037C3.6932 18.4842 3.18287 17.9747 2.86328 17.3477C2.49997 16.6346 2.5 15.7008 2.5 13.834V11.167C2.5 9.30057 2.50011 8.36726 2.86328 7.6543C3.18286 7.02709 3.69311 6.51684 4.32031 6.19727C5.03328 5.83409 5.96659 5.83398 7.83301 5.83398H12.167ZM9.125 10V15H10.875V10H9.125Z"
            fill={color}
        />
        <Path
            d="M10.001 1.70898C11.8188 1.70916 13.292 3.18315 13.292 5.00098V7.45898H6.70898V5.00098C6.70898 3.18304 8.18304 1.70898 10.001 1.70898Z"
            stroke={color}
            strokeWidth={1.75}
        />
    </Svg>
);

export default SvgComponent;
